 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER1NANYANG from '@/components/0_chapter1nanyang'
 import A_CHAPTER2GUARDINGTHECITY from '@/components/1_chapter2guardingthecity'
 import A_CHAPTER3HUANGZHONG from '@/components/2_chapter3huangzhong'
 import A_CHAPTER4ZHANGMANCHENG from '@/components/3_chapter4zhangmancheng'
 import A_CHAPTER5WORRY from '@/components/4_chapter5worry'
 import A_CHAPTER6CONFIRMATIONOFAPHRASE from '@/components/5_chapter6confirmationofaphrase'
 import A_CHAPTER7WAROFSIEGE from '@/components/6_chapter7warofsiege'
 import A_CHAPTER8YELLOWTOWELELITE from '@/components/7_chapter8yellowtowelelite'
 import A_CHAPTER9KILLERWEAPON from '@/components/8_chapter9killerweapon'
 import A_CHAPTER10LIUPINGSADVICE from '@/components/9_chapter10liupingsadvice'
 import A0_CHAPTER11DELUSION from '@/components/10_chapter11delusion'
 import A1_CHAPTER12COURTYARD from '@/components/11_chapter12courtyard'
 import A2_CHAPTER13DIFFICULTIES from '@/components/12_chapter13difficulties'
 import A3_CHAPTER14SOLDIERGENERAL from '@/components/13_chapter14soldiergeneral'
 import A4_CHAPTER15ABITTERSTRUGGLEATTHECITYGATE from '@/components/14_chapter15abitterstruggleatthecitygate'
 import A5_CHAPTER16CITYBREAKING from '@/components/15_chapter16citybreaking'
 import A6_CHAPTER17RETREAT from '@/components/16_chapter17retreat'
 import A7_CHAPTER18DEADEND from '@/components/17_chapter18deadend'
 import A8_CHAPTER19SURPRISEDENDINGS from '@/components/18_chapter19surprisedendings'
 import A9_CHAPTER20EXHORT from '@/components/19_chapter20exhort'
 import A0_CHAPTER21SUBDUE from '@/components/20_chapter21subdue'
 import A1_CHAPTER22LUCESCALAMITY from '@/components/21_chapter22lucescalamity'
 import A2_CHAPTER23DONGZHUOSINFAMY from '@/components/22_chapter23dongzhuosinfamy'
 import A3_CHAPTER24CAPTIVE from '@/components/23_chapter24captive'
 import A4_CHAPTER25WESTCOLDARMY from '@/components/24_chapter25westcoldarmy'
 import A5_CHAPTER26REQUESTBYLIUPINGANDGONGDU from '@/components/25_chapter26requestbyliupingandgongdu'
 import A6_CHAPTER27HUANGZHONGWASDRUNK from '@/components/26_chapter27huangzhongwasdrunk'
 import A7_CHAPTER28PHOENIXMOUNTAIN from '@/components/27_chapter28phoenixmountain'
 import A8_CHAPTER29DISSUADE from '@/components/28_chapter29dissuade'
 import A9_CHAPTER30IFYOUWANTTOFIGHTFIGHT from '@/components/29_chapter30ifyouwanttofightfight'
 import A0_CHAPTER31PHOENIXMOUNTAINWAR from '@/components/30_chapter31phoenixmountainwar'
 import A1_CHAPTER32XANTHOPANAX from '@/components/31_chapter32xanthopanax'
 import A2_CHAPTER33FIRSTTIMEINLUOYANG from '@/components/32_chapter33firsttimeinluoyang'
 import A3_CHAPTER34VIPS from '@/components/33_chapter34vips'
 import A4_CHAPTER35RELAXATIONANDFORTUITOUSENCOUNTERS from '@/components/34_chapter35relaxationandfortuitousencounters'
 import A5_CHAPTER36BOLDMANANDSCHOLAR from '@/components/35_chapter36boldmanandscholar'
 import A6_CHAPTER37FIGHT from '@/components/36_chapter37fight'
 import A7_CHAPTER38FOLLOWME from '@/components/37_chapter38followme'
 import A8_CHAPTER39VISHNUPARTI from '@/components/38_chapter39vishnuparti'
 import A9_CHAPTER40VISHNUPARTII from '@/components/39_chapter40vishnupartii'
 import A0_CHAPTER41VISHNULASTPART from '@/components/40_chapter41vishnulastpart'
 import A1_CHAPTER42CENTERFIVEYEAR from '@/components/41_chapter42centerfiveyear'
 import A2_CHAPTER43DECADALPLOTTING from '@/components/42_chapter43decadalplotting'
 import A3_CHAPTER44LIUHONGSMIND from '@/components/43_chapter44liuhongsmind'
 import A4_CHAPTER45EIGHTHCOMMANDERINCHIEF from '@/components/44_chapter45eighthcommanderinchief'
 import A5_CHAPTER46CAOCAOSRETURNTOBEIJING from '@/components/45_chapter46caocaosreturntobeijing'
 import A6_CHAPTER47CHESS from '@/components/46_chapter47chess'
 import A7_CHAPTER48GUOJIASANALYSIS from '@/components/47_chapter48guojiasanalysis'
 import A8_CHAPTER49GUOJIA from '@/components/48_chapter49guojia'
 import A9_CHAPTER50VISITINGCHENGLI from '@/components/49_chapter50visitingchengli'
 import A0_CHAPTER51CHENGLICHENGYU from '@/components/50_chapter51chenglichengyu'
 import A1_CHAPTER52AFORTUITOUSENCOUNTERATTHETIGERSCAGE from '@/components/51_chapter52afortuitousencounteratthetigerscage'
 import A2_CHAPTER53CHUNYUZHONG from '@/components/52_chapter53chunyuzhong'
 import A3_CHAPTER54THIEVESHAVEGREATPOWER from '@/components/53_chapter54thieveshavegreatpower'
 import A4_CHAPTER55SMALLSOLDIER from '@/components/54_chapter55smallsoldier'
 import A5_CHAPTER56BLOODYWARINTHETIGERSJAILPASS from '@/components/55_chapter56bloodywarinthetigersjailpass'
 import A6_CHAPTER57THETIGERSJAILVICTORY from '@/components/56_chapter57thetigersjailvictory'
 import A7_CHAPTER58UNEXPECTEDGOODNEWS from '@/components/57_chapter58unexpectedgoodnews'
 import A8_CHAPTER59EMPRESSHESHATE from '@/components/58_chapter59empressheshate'
 import A9_CHAPTER60LIUYINGJI from '@/components/59_chapter60liuyingji'
 import A0_CHAPTER61ALONELYHERO from '@/components/60_chapter61alonelyhero'
 import A1_CHAPTER62EIGHTHCOMMANDERINCHIEFSMEETING from '@/components/61_chapter62eighthcommanderinchiefsmeeting'
 import A2_CHAPTER63UNEXPECTEDSETUP from '@/components/62_chapter63unexpectedsetup'
 import A3_CHAPTER64TAKEOVERTHESOUTHOFTHECITY from '@/components/63_chapter64takeoverthesouthofthecity'
 import A4_CHAPTER65CONFLICT from '@/components/64_chapter65conflict'
 import A5_CHAPTER66THECOMPETITIONOFSPIRITANDSPIRIT from '@/components/65_chapter66thecompetitionofspiritandspirit'
 import A6_CHAPTER67WUQONG from '@/components/66_chapter67wuqong'
 import A7_CHAPTER68RESOLVE from '@/components/67_chapter68resolve'
 import A8_CHAPTER69DONGZHUOANDLIRU from '@/components/68_chapter69dongzhuoandliru'
 import A9_CHAPTER70EASTWARDADVANCE from '@/components/69_chapter70eastwardadvance'
 import A0_CHAPTER71NIGHTATTACK from '@/components/70_chapter71nightattack'
 import A1_CHAPTER72YUANSHAO from '@/components/71_chapter72yuanshao'
 import A2_CHAPTER73EMPRESSHESCOMPROMISE from '@/components/72_chapter73empresshescompromise'
 import A3_CHAPTER74HANDISDEATH from '@/components/73_chapter74handisdeath'
 import A4_CHAPTER75DISCERNMENTOFBLUNTPRINCE from '@/components/74_chapter75discernmentofbluntprince'
 import A5_CHAPTER76ASSASSINATION from '@/components/75_chapter76assassination'
 import A6_CHAPTER77THERIGHTTOSENDTROOPS from '@/components/76_chapter77therighttosendtroops'
 import A7_CHAPTER78QINGHEGONG from '@/components/77_chapter78qinghegong'
 import A8_CHAPTER79COMPASSIONATEHEART from '@/components/78_chapter79compassionateheart'
 import A9_CHAPTER80DISORIENTATION from '@/components/79_chapter80disorientation'
 import A0_CHAPTER81GOTOBEDCHAMBER from '@/components/80_chapter81gotobedchamber'
 import A1_CHAPTER82END from '@/components/81_chapter82end'
 import A2_CHAPTER83ADULTERY from '@/components/82_chapter83adultery'
 import A3_CHAPTER84BIGDIPPERYUANSHAO from '@/components/83_chapter84bigdipperyuanshao'
 import A4_CHAPTER85ACCORDINGTOTHEFACTS from '@/components/84_chapter85accordingtothefacts'
 import A5_CHAPTER86CAOCAOPAI from '@/components/85_chapter86caocaopai'
 import A6_CHAPTER87THEUNRULY from '@/components/86_chapter87theunruly'
 import A7_CHAPTER88FORTUITOUSENCOUNTER from '@/components/87_chapter88fortuitousencounter'
 import A8_CHAPTER89UNIONARMY from '@/components/88_chapter89unionarmy'
 import A9_CHAPTER90FIRSTTRIMESTEROFLUBU from '@/components/89_chapter90firsttrimesteroflubu'
 import A0_CHAPTER91EPILOGUE from '@/components/90_chapter91epilogue'
 import A1_CHAPTER92DECADENTDISORDER from '@/components/91_chapter92decadentdisorder'
 import A2_CHAPTER93CONSTRUCTIONHALL from '@/components/92_chapter93constructionhall'
 import A3_CHAPTER94PRINCESSTENTHOUSANDYEARS from '@/components/93_chapter94princesstenthousandyears'
 import A4_CHAPTER95IMPERIALJADESEAL from '@/components/94_chapter95imperialjadeseal'
 import A5_CHAPTER96LUOYANGSANGER from '@/components/95_chapter96luoyangsanger'
 import A6_CHAPTER97EXODUS from '@/components/96_chapter97exodus'
 import A7_CHAPTER98BREAKOUT from '@/components/97_chapter98breakout'
 import A8_CHAPTER99BREAKTHROUGH from '@/components/98_chapter99breakthrough'
 import A9_CHAPTER100CORROBORATION from '@/components/99_chapter100corroboration'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter1nanyang",
 			"name" : "0_chapter1nanyang",
 			"component" : A_CHAPTER1NANYANG
 		},
 		{
 			"path" : "/1_chapter2guardingthecity",
 			"name" : "1_chapter2guardingthecity",
 			"component" : A_CHAPTER2GUARDINGTHECITY
 		},
 		{
 			"path" : "/2_chapter3huangzhong",
 			"name" : "2_chapter3huangzhong",
 			"component" : A_CHAPTER3HUANGZHONG
 		},
 		{
 			"path" : "/3_chapter4zhangmancheng",
 			"name" : "3_chapter4zhangmancheng",
 			"component" : A_CHAPTER4ZHANGMANCHENG
 		},
 		{
 			"path" : "/4_chapter5worry",
 			"name" : "4_chapter5worry",
 			"component" : A_CHAPTER5WORRY
 		},
 		{
 			"path" : "/5_chapter6confirmationofaphrase",
 			"name" : "5_chapter6confirmationofaphrase",
 			"component" : A_CHAPTER6CONFIRMATIONOFAPHRASE
 		},
 		{
 			"path" : "/6_chapter7warofsiege",
 			"name" : "6_chapter7warofsiege",
 			"component" : A_CHAPTER7WAROFSIEGE
 		},
 		{
 			"path" : "/7_chapter8yellowtowelelite",
 			"name" : "7_chapter8yellowtowelelite",
 			"component" : A_CHAPTER8YELLOWTOWELELITE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js